// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    padding: 20px; /* ensures padding on small screens */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-box {
    background-color: #fff;
    padding: 30px 25px;
    border-radius: 12px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    animation: fadeIn 0.3s ease-in-out;
    font-family: 'Segoe UI', sans-serif;
  }
  
  .modal-box h2 {
    font-size: 22px;
    font-weight: 600;
    margin-top: 0;             /* no space above modal box */
    margin-bottom: 25px;       /* extra space below heading */
    text-align: center;
    color: #333;
  }
  
  .modal-box input {
    width: 100%;
    display: block;
    margin: 0 auto 15px auto;
    padding: 12px;
    font-size: 15px;
    border-radius: 6px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    text-align: left; /* optional: keep text left aligned inside input */
  }  
  
  .modal-box input:focus {
    border-color: #007bff;
    outline: none;
  }
  
  .modal-box .error-message {
    background-color: #f8d7da;
    color: #842029;
    padding: 10px;
    border-radius: 6px;
    font-size: 14px;
    text-align: center;
    margin-bottom: 15px;
  }
  
  .modal-box .button-group {
    display: flex;
    gap: 10px;
    justify-content: space-between;
    margin-top: 10px;
  }
  
  .modal-box button {
    flex: 1 1;
    padding: 10px;
    font-size: 15px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .modal-box .btn-primary {
    background-color: #007bff;
    color: #fff;
  }
  
  .modal-box .btn-primary:hover {
    background-color: #0056b3;
  }
  
  .modal-box .btn-secondary {
    background-color: #f1f1f1;
    color: #333;
    border: 1px solid #ccc;
  }
  
  .modal-box .btn-secondary:hover {
    background-color: #e0e0e0;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  /* Responsive enhancements */
  @media (max-width: 480px) {
    .modal-box {
      padding: 25px 20px;
    }
  
    .modal-box h2 {
      font-size: 20px;
    }
  
    .modal-box button {
      font-size: 14px;
    }
  }

  .success-message {
    background-color: #d1e7dd;
    color: #0f5132;
    padding: 12px;
    border-radius: 6px;
    font-size: 15px;
    text-align: center;
    margin-bottom: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/CompleteProfileModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa,EAAE,qCAAqC;IACpD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,0CAA0C;IAC1C,kCAAkC;IAClC,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa,cAAc,6BAA6B;IACxD,mBAAmB,QAAQ,8BAA8B;IACzD,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB,EAAE,kDAAkD;EACtE;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,UAAU;MACV,sBAAsB;IACxB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF;;EAEA,4BAA4B;EAC5B;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    padding: 20px; /* ensures padding on small screens */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .modal-box {\n    background-color: #fff;\n    padding: 30px 25px;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 400px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n    animation: fadeIn 0.3s ease-in-out;\n    font-family: 'Segoe UI', sans-serif;\n  }\n  \n  .modal-box h2 {\n    font-size: 22px;\n    font-weight: 600;\n    margin-top: 0;             /* no space above modal box */\n    margin-bottom: 25px;       /* extra space below heading */\n    text-align: center;\n    color: #333;\n  }\n  \n  .modal-box input {\n    width: 100%;\n    display: block;\n    margin: 0 auto 15px auto;\n    padding: 12px;\n    font-size: 15px;\n    border-radius: 6px;\n    border: 1px solid #ccc;\n    box-sizing: border-box;\n    text-align: left; /* optional: keep text left aligned inside input */\n  }  \n  \n  .modal-box input:focus {\n    border-color: #007bff;\n    outline: none;\n  }\n  \n  .modal-box .error-message {\n    background-color: #f8d7da;\n    color: #842029;\n    padding: 10px;\n    border-radius: 6px;\n    font-size: 14px;\n    text-align: center;\n    margin-bottom: 15px;\n  }\n  \n  .modal-box .button-group {\n    display: flex;\n    gap: 10px;\n    justify-content: space-between;\n    margin-top: 10px;\n  }\n  \n  .modal-box button {\n    flex: 1;\n    padding: 10px;\n    font-size: 15px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .modal-box .btn-primary {\n    background-color: #007bff;\n    color: #fff;\n  }\n  \n  .modal-box .btn-primary:hover {\n    background-color: #0056b3;\n  }\n  \n  .modal-box .btn-secondary {\n    background-color: #f1f1f1;\n    color: #333;\n    border: 1px solid #ccc;\n  }\n  \n  .modal-box .btn-secondary:hover {\n    background-color: #e0e0e0;\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: scale(0.95);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n  \n  /* Responsive enhancements */\n  @media (max-width: 480px) {\n    .modal-box {\n      padding: 25px 20px;\n    }\n  \n    .modal-box h2 {\n      font-size: 20px;\n    }\n  \n    .modal-box button {\n      font-size: 14px;\n    }\n  }\n\n  .success-message {\n    background-color: #d1e7dd;\n    color: #0f5132;\n    padding: 12px;\n    border-radius: 6px;\n    font-size: 15px;\n    text-align: center;\n    margin-bottom: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
